export const messages = {
  en: {
    productSpec: {
      title: 'Product Specification',
      query: {
        title: 'Query Conditions',
        specName: 'Specification Name',
        specId: 'Specification ID',
        search: 'Search',
        reset: 'Reset'
      },
      table: {
        title: 'Product Specifications',
        specId: 'Spec ID',
        specName: 'Spec Name',
        specValue: 'Spec Value',
        createTime: 'Create Time',
        actions: 'Actions',
        edit: 'Edit',
        delete: 'Delete',
        add: 'Add'
      },
      dialog: {
        addTitle: 'Add Specification',
        editTitle: 'Edit Specification',
        deleteTitle: 'Confirm Operation',
        deleteContent: 'Are you sure to delete this product specification?',
        cancel: 'Cancel',
        confirm: 'Confirm',
        name: 'Name',
        spec: 'Specification',
        value: 'Value',
        tips1: 'e.g. Color, Size, Capacity, Dimension, Weight',
        tips2: 'e.g. Red, Small, 500ML, 5.5inch, 1kg'
      },
      message: {
        addSuccess: 'Add successfully',
        editSuccess: 'Edit successfully',
        deleteSuccess: 'Delete successfully',
        nameRequired: 'Specification name is required',
        specRequired: 'Specification is required',
        valueRequired: 'Specification value is required'
      }
    }
  },
  zh: {
    productSpec: {
      title: '商品规格',
      query: {
        title: '查询条件',
        specName: '规格名称',
        specId: '规格编号',
        search: '查询',
        reset: '重置'
      },
      table: {
        title: '商品规格',
        specId: '规格编号',
        specName: '规格名称',
        specValue: '规格值',
        createTime: '创建时间',
        actions: '操作',
        edit: '修改',
        delete: '删除',
        add: '添加'
      },
      dialog: {
        addTitle: '添加规格',
        editTitle: '修改规格',
        deleteTitle: '请确认您的操作',
        deleteContent: '确定删除商品规格',
        cancel: '取消',
        confirm: '确认',
        name: '名称',
        spec: '规格',
        value: '值',
        tips1: '如：颜色，大小，容量，尺寸，重量',
        tips2: '如：红色，小，500ML，5.5寸，1kg'
      },
      message: {
        addSuccess: '添加成功',
        editSuccess: '修改成功',
        deleteSuccess: '删除成功',
        nameRequired: '规格名称不能为空',
        specRequired: '规格不能为空',
        valueRequired: '规格值不能为空'
      }
    }
  }
}